import React from 'react'

import AccommodationItemSummary from './AccommodationItemSummary'
import AttractionItemSummary from './AttractionItemSummary'
import BusItemSummary from './BusItemSummary'
import CarRentalItemSummary from './CarRentalItemSummary'
import EventItemSummary from './EventItemSummary'
import FerryItemSummary from './FerryItemSummary'
import FlightItemSummary from './FlightItemSummary'
import NoteItemSummary from './NoteItemSummary'
import OtherTransportItemSummary from './OtherTransportSummary'
import RestaurantBarItemSummary from './RestaurantBarItemSummary'
import ThingTodoItemSummary from './ThingTodoItemSummary'
import TourAndCruiseItemSummary from './TourAndCruiseItemSummary'
import TrainItemSummary from './TrainItemSummary'

import ExperienceItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary/ExperienceItemSummary'
import { TripItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable } from 'tripPlanner/utils'

interface Props {
  item: TripItem
  editorialSummary?: string
}
function TripItemSummary({ item, editorialSummary }: Props) {
  switch (item.type) {
    case 'ACCOMMODATION':
      return <AccommodationItemSummary item={item} />
    case 'ATTRACTION':
      return <AttractionItemSummary item={item} editorialSummary={editorialSummary} />
    case 'CAR_RENTAL':
      return <CarRentalItemSummary item={item} />
    case 'CRUISE':
    case 'TOUR':
      return <TourAndCruiseItemSummary item={item} />
    case 'EXPERIENCE':
      return <ExperienceItemSummary item={item} />
    case 'THING_TO_DO':
      return <ThingTodoItemSummary item={item} />
    case 'EVENT':
      return <EventItemSummary item={item} />
    case 'FLIGHT':
      return <FlightItemSummary item={item} />
    case 'NOTE':
      return <NoteItemSummary item={item} />
    case 'RESTAURANT_BAR':
      return <RestaurantBarItemSummary item={item} />
    case 'BUS':
      return <BusItemSummary item={item} />
    case 'FERRY':
      return <FerryItemSummary item={item} />
    case 'OTHER_TRANSPORT':
      return <OtherTransportItemSummary item={item} />
    case 'TRAIN':
      return <TrainItemSummary item={item} />
    default:
      return assertUnreachable(item)
  }
}

export default TripItemSummary
